<template>
  <div class="file">
    <div class="head">
      <div class="title">
        <h2>徐勤康个人档案</h2>
        <p>
          <span>邀请完善个人档案 </span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span class="left"> 打印员工档案</span>
        </p>
      </div>
      <div class="photo">
        <div class="img">
          <img alt="" src="../../assets/photo/we.png">
        </div>
      </div>
      <div class="name">
        <p>
          <span>徐勤康</span>
          <span>&nbsp;&nbsp;</span>
          <el-tag size="mini" style="color:#4688F6;border:0;">正式</el-tag>
        </p>
      </div>
      <div class="dept">
        <p>
          <span>产品技术部-研发部</span>
          <span>&nbsp;&nbsp;</span>
          <el-tag size="mini">主厂站</el-tag>
        </p>
      </div>
      <div class="age">
        <p>
          <span class="go">完善入职日期</span>
          <span>，自动计算司龄</span>
        </p>
      </div>
    </div>
    <div class="information">
      <Timeline>
        <TimelineItem>
          <p class="roll" @click="roll('xtxx')">系统信息</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('jbxx')">基本信息</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('gzxx')">工作信息</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('grxx')">个人信息</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('xlxx')">学历信息</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('yhkxx')">银行卡信息</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('htxx')">合同信息</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('jjlxr')">紧急联系人</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('jtxx')">家庭信息</p>
        </TimelineItem>
        <TimelineItem>
          <p class="roll" @click="roll('grcl')">个人材料</p>
        </TimelineItem>
      </Timeline>
      <div id="cont" class="content">
        <div id="xtxx" class="box">
          <Divider orientation="left">系统信息</Divider>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item class="item" label="实人认证">
              <span>未授权</span>
              <span>&nbsp;&nbsp;</span>
              <span class="blue">详情</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="jbxx" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">基本信息</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="姓名"></el-descriptions-item>
            <el-descriptions-item label="邮箱"></el-descriptions-item>
            <el-descriptions-item label="厂站"></el-descriptions-item>
            <el-descriptions-item label="主厂站"></el-descriptions-item>
            <el-descriptions-item label="直属主管"></el-descriptions-item>
            <el-descriptions-item label="职位"></el-descriptions-item>
            <el-descriptions-item label="手机号"></el-descriptions-item>
            <el-descriptions-item label="工号"></el-descriptions-item>
            <el-descriptions-item label="分机号"></el-descriptions-item>
            <el-descriptions-item label="办公地点"></el-descriptions-item>
            <el-descriptions-item label="备注"></el-descriptions-item>
            <el-descriptions-item label="入职时间"></el-descriptions-item>
            <el-descriptions-item label="司龄（系统计算）"></el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="gzxx" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">工作信息</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="员工类型"></el-descriptions-item>
            <el-descriptions-item label="员工状态"></el-descriptions-item>
            <el-descriptions-item label="试用期"></el-descriptions-item>
            <el-descriptions-item label="实际转正日期"></el-descriptions-item>
            <el-descriptions-item label="计划转正日期"></el-descriptions-item>
            <el-descriptions-item label="岗位职级"></el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="grxx" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">个人信息</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="身份证姓名"></el-descriptions-item>
            <el-descriptions-item label="证件号码"></el-descriptions-item>
            <el-descriptions-item label="出生日期"></el-descriptions-item>
            <el-descriptions-item label="年龄"></el-descriptions-item>
            <el-descriptions-item label="性别"></el-descriptions-item>
            <el-descriptions-item label="民族"></el-descriptions-item>
            <el-descriptions-item label="身份证地址"></el-descriptions-item>
            <el-descriptions-item label="证件有效期"></el-descriptions-item>
            <el-descriptions-item label="婚姻状况"></el-descriptions-item>
            <el-descriptions-item label="首次参加工作时间"></el-descriptions-item>
            <el-descriptions-item label="工龄"></el-descriptions-item>
            <el-descriptions-item label="户籍类型"></el-descriptions-item>
            <el-descriptions-item label="住址"></el-descriptions-item>
            <el-descriptions-item label="政治面貌"></el-descriptions-item>
            <el-descriptions-item label="个人社保账号"></el-descriptions-item>
            <el-descriptions-item label="个人公积金账号"></el-descriptions-item>
            <el-descriptions-item label="家乡"></el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="xlxx" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">学历信息</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="学历"></el-descriptions-item>
            <el-descriptions-item label="毕业院校"></el-descriptions-item>
            <el-descriptions-item label="毕业时间"></el-descriptions-item>
            <el-descriptions-item label="所学专业"></el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="yhkxx" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">银行卡信息</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="银行卡号"></el-descriptions-item>
            <el-descriptions-item label="开户行"></el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="htxx" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">合同信息</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="合同公司"></el-descriptions-item>
            <el-descriptions-item label="合同类型"></el-descriptions-item>
            <el-descriptions-item label="首次合同起始日"></el-descriptions-item>
            <el-descriptions-item label="首次合同到期日"></el-descriptions-item>
            <el-descriptions-item label="现合同起始日"></el-descriptions-item>
            <el-descriptions-item label="现合同到期日"></el-descriptions-item>
            <el-descriptions-item label="合同期限"></el-descriptions-item>
            <el-descriptions-item label="续签次数"></el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="jjlxr" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">紧急联系人</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="紧急联系人姓名"></el-descriptions-item>
            <el-descriptions-item label="联系人关系"></el-descriptions-item>
            <el-descriptions-item label="联系人电话"></el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="jtxx" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">家庭信息</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="姓名(家人)"></el-descriptions-item>
            <el-descriptions-item label="关系"></el-descriptions-item>
            <el-descriptions-item label="性别"></el-descriptions-item>
            <el-descriptions-item label="生日"></el-descriptions-item>
            <el-descriptions-item label="电话"></el-descriptions-item>
          </el-descriptions>
        </div>
        <div id="grcl" class="box">
          <div class="divider">
            <div style="width:770px">
              <Divider orientation="left">个人材料</Divider>
            </div>
            <div class="edit">编辑</div>
          </div>
          <el-descriptions :column="2" class="margin-top">
            <el-descriptions-item label="身份证(人像面)">未上传</el-descriptions-item>
            <el-descriptions-item label="身份证(国徽面)">未上传</el-descriptions-item>
            <el-descriptions-item label="学历证书">未上传</el-descriptions-item>
            <el-descriptions-item label="学位证书">未上传</el-descriptions-item>
            <el-descriptions-item label="前公司离职证明">未上传</el-descriptions-item>
            <el-descriptions-item label="员工照片">未上传</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default ({
  name: 'personalFiles',
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    roll(name) {
      let target = document.getElementById(name);
      let parent = document.getElementById('cont');
      parent.scrollTo(0, target.offsetTop - parent.offsetTop);
    }
  }
})
</script>

<style lang="less" scoped>
.file {
  height: 650px;

  .head {
    height: 230px;

    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      padding-left: 380px;

      h2 {
        width: 200px;
        font-size: 19px;
        color: #000;
        text-align: center;
      }

      p {
        width: 250px;

        span {
          cursor: pointer;
        }

        .left {
          color: #4688F6;
        }
      }
    }

    .photo {
      width: 960px;

      display: flex;
      flex-direction: column;
      align-items: center;

      .img {
        width: 70px;
        height: 70px;
        border-radius: 10px;
        margin-top: 30px;

        img {
          border-radius: 10px;
          width: 100%;
          height: 100%;
        }
      }
    }

    .name {
      width: 960px;

      p {
        width: 200px;
        margin-left: 400px;
        text-align: center;
        margin-top: 10px;
        font-size: 20px;
        font-weight: 600;
        color: #000;
        line-height: 40px;
      }
    }

    .dept {
      p {
        text-align: center;
        color: #000;
      }
    }

    .age {
      p {
        text-align: center;

        .go {
          color: #4688F6;
        }
      }
    }
  }

  .information {
    display: flex;
    flex-direction: row;

    .roll {
      cursor: pointer;
    }

    .content {
      overflow-y: scroll;
      height: 440px;
      width: 845px;
      margin-left: 20px;
      padding: 10px;

      .box {
        .margin-top {
          margin-left: 50px;

          .blue {
            color: #4688F6;
            cursor: pointer;
          }

          .item {
            margin: 50px 50px;
          }
        }

        .divider {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          .edit {
            width: 40px;
            line-height: 56px;
            color: #4688F6;
            cursor: pointer;
            font-weight: 600;
          }
        }
      }
    }

    .content::-webkit-scrollbar {
      width: 5px;
    }

    .content::-webkit-scrollbar-thumb {
      background-color: rgb(231, 231, 231);
      border-radius: 5px;
    }
  }
}

</style>
